import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class AgentesService {
  url = environment.urlWhats;
  urlPy = environment.urlPy;
  constructor(private http: HttpClient) { }


  crearNuevoAgente(data, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('rol-token', token);
    return this.http.post(urlBack + `/nuevoAgente/${id}/${role}?ad_planIt=true`, data, { headers });
  }

  validarCreacionAgentes(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/valCreacionAgente/${idAdmin}/${id}/${role}?ad_planIt=true`, { headers });
  }

  //todos los agentes (eliminados y no eliminados)
  getAgentes(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/agentes/${idAdmin}/${id}/${role}`, { headers });
  }

  getNumeroId(idNum, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getNumeroId/${idNum}/${id}/${role}`, { headers });
  }

  //todos los agentes (no eliminados)
  getAgentesSinEliminar(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/agentes/${idAdmin}/${id}/${role}?eliminados=1`, { headers });
  }

  getAgentesSinEliminarConf(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/agentes/${idAdmin}/${id}/${role}?eliminados=1&conf=1`, { headers });
  }


  getAgentesActivos(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/agentes/${idAdmin}/${id}/${role}?activos=1`, { headers });
  }

  eliminarAgente(idAdmin, idAgente, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.delete(`${urlBack}/deleteAgente/${idAdmin}/${idAgente}/${id}/${role}?ad_planIt=true`, { headers });
  }

  getAgente(idAdmin, idAgente, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/agentes/${idAdmin}/${id}/${role}/${idAgente}`, { headers });
  }

  consultarAsignacionAgente(idAdmin, data, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/planIt/consultarAsignacionAgente/${idAdmin}/${id}/${role}`, data, { headers });

  }


  consultarAsignacionAgenteFacebookMessenger(idAdmin, data, id, role, token, idFacebookMessenger, urlBack, tipoCanal) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/planIt/consultarAsignacionAgente/${idAdmin}/${id}/${role}?idFacebookMessenger=${idFacebookMessenger}&idMuro=0&tipoCanal=${tipoCanal}`, data, { headers });

  }

  consultarAsignacionAgenteMuro(idAdmin, data, id, role, token, idFacebookMessenger, idMuro, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/planIt/consultarAsignacionAgente/${idAdmin}/${id}/${role}?idFacebookMessenger=${idFacebookMessenger}&idMuro=${idMuro}&tipoCanal=2`, data, { headers });

  }



  actualizarAgente(idAdmin, idAgente, data, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('rol-token', token);
    return this.http.put(`${urlBack}/updateAgente/${idAdmin}/${idAgente}/${id}/${role}`, data, { headers });
  }

registrarStatusAgente(idAdmin, id, role, token, urlBack, body) { 
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('rol-token', token);
    const url = `${urlBack}/registro-status-agente/${idAdmin}/${id}/${role}`;
    
    return this.http.post(url, body, { headers });
  }

  actualizarEstadoAgente(idAdmin, correo, id, role, token, urlBack, data) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('rol-token', token);
    console.log(`${urlBack}/updateAgenteMail/${idAdmin}/${correo}/${id}/${role}`, 'actualizar agente por correo');
    return this.http.put(`${urlBack}/updateAgenteMail/${idAdmin}/${correo}/${id}/${role}`, data, { headers });
  }

  tablaAgentesDashboard(idAdmin, id, rol, token) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.url}/getDashboardAgentes/${idAdmin}/${id}/${rol}`, { headers });
  }

  tablaAgentesDashboardFiltro(idAdmin, id, rol, token, query, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getDashboardAgentes/${idAdmin}/${id}/${rol}${query}`, { headers });
  }

  tablaAgentesDashboardFiltro2(idAdmin, id, rol, token, query, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getDashboardAgentes/${idAdmin}/${id}/${rol}${query}`, { headers });
  }

  tablaAgentesDashboardSemaforo(idAdmin, id, rol, token) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.url}/datosAgenteSemaforo/${idAdmin}/${id}/${rol}`, { headers });
  }

  consultarPlanitllasAgentes(idAdmin, id, role, token, urlBack) {
    console.log(idAdmin, id, role, token, urlBack, 'servicio api plamt')
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/registroPlantillasAgente/${idAdmin}/${id}`, { headers });
  }

  consultarMetricasAgentesPy(idAdmin, inicio, fin) {
    return this.http.get(`${this.urlPy}/?idAdmin=${idAdmin}&inicio='${inicio}'&fin='${fin}'`);
  }


  dashboardAgente(idAdmin, idAgente, id, role, token, data, urlBack) {

    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/getDatosDashboardAgente/${idAdmin}/${idAgente}/${id}/${role}`, data, { headers });
  }


  // ------------- Seccion de Colaboradores -----------------------
  consultarColaboradores(idAdmin) {
    return this.http.get(`${this.url}/getColaboradores/${idAdmin}?profesion=Doctor`);
  }

}
